import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer.js";
import anime from 'animejs/lib/anime.es.js';
import send from "./logos/send.png";

export function Contact() {
    const [username, setUsername] = useState(null);
    const [comment, setComment] = useState(null);
    const [error, setError] = useState(null);

    const animation = useRef(null);
    useEffect(() => {
        animation.current = anime({
          targets: '.home-content, .divider-h',
          translateY: [100, 0],
          opacity: [0, 1],
          duration: 1500,
          loop: false,
          delay: anime.stagger(200),
          easing: "easeOutExpo"
        })
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        setError("This functionality is currently disabled.");
    }

    return (
        <>
            <div id="main">
            <div id="home-container">
            <h2 className="info-tite">Reach Out To Us</h2>
            {error && <p style={{ color: "#daa520", marginTop: "10px", paddingBottom: "10px", textAlign: "center" }}>{error}</p>}
            <div id="home-animation">
            <div className="home-content">
            <form onSubmit={handleSubmit} className="contact-form">
                <label>Email</label>
                <input
                id="username"
                type="email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                />
                <div className="radio-container">
                <div className="radio-div">
                <input
                type="radio"
                id="businessInq"
                name="reqType"
                value="businessInq"
                />
                <p htmlFor="businessInq">Business Inquiry</p>
                </div>
                <div className="radio-div">
                <input
                type="radio"
                id="featureReq"
                name="reqType"
                value="featureReq"
                />
                <p htmlFor="featureReq">Feature Request</p>
                </div>
                <div className="radio-div">
                <input
                type="radio"
                id="techSupport"
                name="reqType"
                value="techSupport"
                />
                <p htmlFor="techSupport">Technical Support</p>
                </div>
                <div className="radio-div">
                <input
                type="radio"
                id="other"
                name="reqType"
                value="other"
                />
                <p htmlFor="other">Other</p>
                </div>
                </div>
                <label style={{paddingTop: "25px"}}>What's on your mind?</label>
                <textarea
                id="comment"
                type="text"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                required
                />
                <button type="submit"><p>Send</p> <img id="contact-send" alt="" src={send}></img></button>
            </form>
            </div>
            <div className="divider-h"></div>
            </div>
            </div>
            </div>
            <Footer />
        </>
    )
}